export const ATOM_KEY = {
    CHECK_IN: "CHECK_IN",
    CHECK_OUT: "CHECK_OUT",
    CHECK_FAKE: "CHECK_FAKE",
    CHECK_COUNT: "CHECK_COUNT",
    CHECK_FIRST: "CHECK_FIRST",
    CHECK_MAX: "CHECK_MAX",
    TOGGLE_ON_OFF: "TOGGLE_ON_OFF",
    RE_NEW_DATA: "RE_NEW_DATA",
    RESERVE_SUCCESS: "RESERVE_SUCCESS",
    RESERVE_ON_PRICE: "RESERVE_ON_PRICE",
    RESERVE_OFF_PRICE: "RESERVE_OFF_PRICE",
    RE_NEW_PRICE: "RE_NEW_PRICE",
    PRICE_SUCCESS: "PRICE_SUCCESS",
    SELECTED_RESERVE_ROOM: "SELECTED_RESERVE_ROOM",
    SELECTED_ADULT_PERSON: "SELECTED_ADULT_PERSON",
    SELECTED_CHILD_PERSON: "SELECTED_CHILD_PERSON",
    SELECTED_INFANT_PERSON: "SELECTED_INFANT_PERSON",
    BOOKING_ENGINE: "BOOKING_ENGINE",
    VIMEO_DATA: "VIMEO_DATA",
    PENSION_NAME: "PENSION_NAME",
};
